module.exports = __webpack_public_path__ + "img/4b43585.png";